<dm-content-divider variant="line" />

<div class="lp-mein-profil-row">
  <dm-label-section class="lp-mein-profil-row__label" [label]="label()" [hint]="hint()" [required]="required()" />
  <div class="lp-mein-profil-row__control">
    <ng-content />
  </div>
</div>
